import { Route } from 'vue-router';
import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../config';

import { GuardClass, GuardResolveFunction } from '../models';

import { ROUTER_CONSTS } from '../router/router.consts';

import { APP_CONSTS } from '../store/app/app.consts';

export class SetFullscreenFromUrlGuard extends GuardClass {

  public static async execute(to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    const store = CONTAINER.get<Store<any>>(TYPES.Store);
    const fullscreen = (to.query[ROUTER_CONSTS.query.fullscreen] === 'true');
    await store.dispatch(`${APP_CONSTS.moduleName}/${APP_CONSTS.actions.setFullscreen}`, fullscreen);
    next();
  }

}
